import React from "react";
import { Dialog, Flex, Text, Button } from "@radix-ui/themes";

export function SevenRoomsPushScopeDialog({ isOpen, onOpenChange, onChoose }) {
  return (
    <Dialog.Root open={isOpen} onOpenChange={onOpenChange}>
      <Dialog.Content maxWidth="500px">
        <Dialog.Title>Choose where pushing resumes</Dialog.Title>
        <Dialog.Description size="2" mb="3">
          Choose whether to process WiFi connections recorded while pushing was off,
          or skip that backlog and send only connections recorded from now onward.
        </Dialog.Description>
        <Text size="2" color="gray" mb="4" as="p">
          This choice only affects pushing to SevenRooms. Your pull setting is unchanged.
        </Text>
        <Flex justify="end" gap="3" wrap="wrap">
          <Button variant="soft" color="accent" onClick={() => onChoose("resume")}>
            Resume from last sync
          </Button>
          <Button
            variant="outline"
            color="gray"
            onClick={() => onChoose("continue_from_now")}
          >
            Start from now
          </Button>
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  );
}
